import { ApiHttpService } from '../../services'
export const PrintDatamatrixModule = {
    namespaced: true,
    state: {

        postLoading : false,
        form : {},
        initialFormData : {
            date : null,
            items : [],
        },      
        formStatus : 'create',
        request : null,
        loading : false,
    },
    mutations: {
        addRequest : (state, req) => {
            state.request = {cancel : req.cancel, msg : "loading"}

        },
        cancelRequest : (state) => {

            if(state.request != null){
                state.request.cancel()
            }
            state.loading = true
        },
        clearOldRequest(state, message) {
            state.request.msg = message;
            state.request = null;
        },
        setData(state, payload) {
            state.data = payload
        },
        loadingTrue(state) {
            state.loading = true
        },
        setLoading(state, payload) {
            state.loading = payload
        },
        setPostLoadingTrue: (state) => {
            state.postLoading = true
        },
        setPostLoadingFalse: (state) => {
            state.postLoading = false
        },
      

        setFormData : (state, payload)=>{

            state.form = payload
        },

        setFormDataItems : (state, payload)=>{
            state.form.items = payload
        },
        setFormRowObject : (state, payload)=>{
            state.form.rowObject = payload
        },

        setEmptyForm : (state) => {
            state.form = JSON.parse(JSON.stringify(state.initialFormData))
        },

    
    },
    actions : {
      

        async storeRecord({ commit }, payload) {
            return await new Promise((resolve, reject) => {
                commit('setPostLoadingTrue')
                    const parsePayload = JSON.parse(JSON.stringify(payload))
                    const configParams = {
                        req : "PrintDatamatrixModule/req",
                        loadingTrue : "PrintDatamatrixModule/loadingTrue",
                        addRequest : "PrintDatamatrixModule/addRequest",
                        cancelRequest : "PrintDatamatrixModule/cancelRequest",
                        clearOldRequest : "PrintDatamatrixModule/clearOldRequest"
                    }
                    ApiHttpService.post('print-datamatrix',parsePayload,configParams).then((response) => {
                        commit('setPostLoadingFalse')
                        resolve(response.data)
                    }).catch((error) => {
                        commit('setPostLoadingFalse')
                        reject(error)
                    })
            })
        },

    },
    getters: {
       
        req: state => state.request,
        initialFormObject: state => state.initialFormData,
        formData: state => state.form,
        postLoading: state => state.postLoading,

    }
}



